import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useRouteError } from 'react-router-dom';
import { useAnalysis } from '../../utils/contexts/AnalysisContext';

import './GenericError.scss';

const GenericError = ({ code = '', fullscreen = true }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { trackRawEvent, ANALYSIS_SEGMENT } = useAnalysis();

  // collect error that caused this page to be rendered
  let error = useRouteError();
  console.error(error);

  if (Sentry.getClient()) {
    // send error to Sentry
    Sentry.captureException(error);
  }

  const handleExitButtonClick = (event) => {
    event.stopPropagation();
    navigate(`/`);
  };

  useEffect(() => {
    trackRawEvent(ANALYSIS_SEGMENT.SEGMENT_EVENTS.Error_Page_Viewed, {
      error: code
    });
  }, []);

  return (
    <div className='generic-error-page'>
      <div
        className={
          fullscreen
            ? 'generic-error-page__container__fullscreen'
            : 'generic-error-page__container'
        }
      >
        <div className='generic-error-page__text'>
          {code == 404 ? (
            t('error_message_generic_404')
          ) : code == 500 ? (
            t('error_message_generic_500')
          ) : (
            <span>
              {t('error_message')}{' '}
              <a href='mailto:soporte@blueberrymath.ai'>
                soporte@blueberrymath.ai
              </a>
            </span>
          )}
        </div>
        <div
          className='generic-error-page__button'
          onClick={handleExitButtonClick}
        >
          <div variant='contained' disableElevation>
            {t('error_button_generic')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenericError;
